module.exports = __webpack_public_path__ + "static/Stakeholder-23cd3139b1d38d9471718fec47c82872.webp";